const initialState = {
    stub: [],
    heading: []
}
export default (state = initialState, action) => {
    switch(action.type){
        case 'STUB_UP':
            const stubNoSelected = state.stub.filter(e => action.payload.indexOf(e) == -1);
            const stub = action.payload.concat(stubNoSelected);
            return { ...state, stub }
        case 'HEAD_UP':
            const headNoSelected = state.heading.filter(e => action.payload.indexOf(e) == -1);
            const heading = action.payload.concat(headNoSelected);
            return { ...state, heading }
        case 'STUB_DOWN':
            const stubNoSelectedDown = state.stub.filter(e => action.payload.indexOf(e) == -1);
            const stubDown = stubNoSelectedDown.concat(action.payload);
            return { ...state, stub: stubDown }
        case 'HEADING_DOWN':
            const headNoSelectedDown = state.heading.filter(e => action.payload.indexOf(e) == -1);
            const headingDown = headNoSelectedDown.concat(action.payload);
            return { ...state, heading: headingDown }
        case 'HEAD_LEFT':
            const headNoSelectedLeftt = state.heading.filter(e => action.payload.indexOf(e) == -1);
            const stubNoSelectedLeft = state.stub.filter(e => action.payload.indexOf(e) == -1);
            const headmoveLeft = stubNoSelectedLeft.concat(action.payload);
            return { ...state, stub: headmoveLeft, heading: headNoSelectedLeftt }
        case 'STUB_RIGTH':
            const stubNoSelectedRight = state.stub.filter(e => action.payload.indexOf(e) == -1);
            const headNoSelectedRight = state.heading.filter(e => action.payload.indexOf(e) == -1);
            const headmoveRight = headNoSelectedRight.concat(action.payload);
            return { ...state, stub: stubNoSelectedRight, heading: headmoveRight }
        case 'SET_COLUMN_FROM_METADATA':
            return {...state, stub: action.payload.stub, heading: action.payload.heading};
        default: return state;
    }
}